export const CUSTOMER_FORM_NOTE_TAG = 'customer-form-v1';

export const formTypeTitles = {
  entitlement: {
    ar: 'مخالصة تسليم فلاشة',
    en: 'Media Delivery Clearance',
  },
  financialCompensation: {
    ar: 'مخالصة تعويض مالية',
    en: 'Financial Compensation Clearance',
  },
  clearanceWithDeposit: {
    ar: 'مخالصة الغاء العقد مع استرجاع العربون',
    en: 'Contract Cancellation With Deposit Return',
  },
  clearanceNoDeposit: {
    ar: 'مخالصة الغاء العقد بدون استرجاع المستحقات المالية',
    en: 'Contract Cancellation Without Deposit Return',
  },
};

export const buildCustomerFormNote = ({
  formType,
  civilId,
  agreementNo,
  eventDate,
  iban,
  reason,
  deliveryDetails,
  extraNotes,
  customerPhone,
}: any) => {
  return JSON.stringify({
    _tag: CUSTOMER_FORM_NOTE_TAG,
    _version: 1,
    formType,
    civilId: civilId || '',
    agreementNo: agreementNo || '',
    eventDate: eventDate || '',
    iban: iban || '',
    reason: reason || '',
    deliveryDetails: deliveryDetails || '',
    extraNotes: extraNotes || '',
    customerPhone: customerPhone || '',
    savedAt: new Date().toISOString(),
  });
};

export const parseCustomerFormNote = (note: any) => {
  if (!note || typeof note !== 'string') {
    return null;
  }

  try {
    const parsed = JSON.parse(note);
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }

    if (parsed?._tag === CUSTOMER_FORM_NOTE_TAG) {
      return parsed;
    }

    const extra =
      parsed?.extra && typeof parsed.extra === 'object' ? parsed.extra : {};
    const merged = {
      ...parsed,
      ...extra,
    };

    const hasKnownFields = [
      merged?.formType,
      merged?.civilId,
      merged?.agreementNo,
      merged?.eventDate,
      merged?.iban,
      merged?.reason,
      merged?.deliveryDetails,
      merged?.extraNotes,
      merged?.customerPhone,
    ].some((value: any) => {
      if (value === 0) return true;
      if (value === undefined || value === null) return false;
      return `${value}`.trim() !== '';
    });

    if (!hasKnownFields) {
      return null;
    }

    return {
      _tag: CUSTOMER_FORM_NOTE_TAG,
      _version: merged?._version || 0,
      formType: merged?.formType || '',
      civilId: merged?.civilId || '',
      agreementNo: merged?.agreementNo || '',
      eventDate: merged?.eventDate || merged?.startDate || '',
      iban: merged?.iban || merged?.bankIban || merged?.IBAN || '',
      reason: merged?.reason || merged?.desc || '',
      deliveryDetails: merged?.deliveryDetails || '',
      extraNotes: merged?.extraNotes || '',
      customerPhone: merged?.customerPhone || '',
      savedAt: merged?.savedAt || '',
    };
  } catch (error) {
    return null;
  }
};
